import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionModalidadSectorialByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionModalidadSectorialByUser = () => {
  const [loadingGetPrestacionModalidadSectorialByUser, setLoadingGetPrestacionModalidadSectorialByUser] = useState(false);
  const [successGetPrestacionModalidadSectorialByUser, setSuccessGetPrestacionModalidadSectorialByUser] = useState(false);
  const [errorGetPrestacionModalidadSectorialByUser, setErrorGetPrestacionModalidadSectorialByUser] = useState<any>(null);
  const [dataGetPrestacionModalidadSectorialByUser, setDataPrestacionModalidadSectorialByUser] = useState<any>(null);

  const [statusGetPrestacionModalidadSectorialByUser, setStatusGetPrestacionModalidadSectorialByUser] =
    useState<StatusGetPrestacionModalidadSectorialByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionModalidadSectorialByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPrestacionModalidadSectorialByUser(true);
    setSuccessGetPrestacionModalidadSectorialByUser(false);
    setErrorGetPrestacionModalidadSectorialByUser(null);

    try {
      const res = await apirecord.getSolicitudModalidadSectorialByUser(userId, expedienteId);

      setStatusGetPrestacionModalidadSectorialByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetPrestacionModalidadSectorialByUser(true);
      setDataPrestacionModalidadSectorialByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionModalidadSectorialByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetPrestacionModalidadSectorialByUser(err);
      console.error("Error en getPrestacionModalidadSectorialByUser:", err);

      throw err;

    } finally {
      setLoadingGetPrestacionModalidadSectorialByUser(false);
    }
  };

  return {
    getPrestacionModalidadSectorialByUser,
    loadingGetPrestacionModalidadSectorialByUser,
    successGetPrestacionModalidadSectorialByUser,
    errorGetPrestacionModalidadSectorialByUser,
    dataGetPrestacionModalidadSectorialByUser,
    statusGetPrestacionModalidadSectorialByUser
  };
};

export default useGetPrestacionModalidadSectorialByUser;
